/* Reuse V6's browser controls so filters, counts and pagination stay in sync. */
(() => {
  // Keep the coconut crown in view on narrow phones. The original canvas reads
  // this same source crop; CSS and the paper mask use the image's object-position.
  const narrowPhone = matchMedia('(max-width: 360px)');
  const island = document.getElementById('shop-designs');
  const syncIslandCrop = () => { if (island) island.dataset.revealPositionX = narrowPhone.matches ? '0.68' : '0.5'; };
  syncIslandCrop();
  narrowPhone.addEventListener('change', syncIslandCrop);
  let navigating = false;
  const waitForExpanded = panel => new Promise(resolve => {
    if (panel.dataset.paperState !== 'minimized') { resolve(true); return; }
    const observer = new MutationObserver(() => {
      if (panel.dataset.paperState === 'expanded') finish(true);
    });
    const finish = expanded => { observer.disconnect(); clearTimeout(timeout); resolve(expanded); };
    const timeout = setTimeout(() => finish(false), 1600);
    observer.observe(panel, { attributes: true, attributeFilter: ['data-paper-state'] });
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.v65-search');
    if (!form || event.defaultPrevented) return;
    const query = form.querySelector('input[type="search"]').value.trim();
    const browser = document.querySelector('[data-design-browser]');
    const input = browser?.querySelector('[data-product-search-input]');
    const reset = browser?.querySelector('[data-product-finder-reset]');
    const heading = browser?.querySelector('#all-designs-heading');
    if (!query || !input || !reset || !heading) return;
    event.preventDefault();
    if (browser.dataset.paperState === 'minimized') {
      browser.querySelector('[data-paper-minimize]')?.click();
      if (!await waitForExpanded(browser)) return;
    }
    reset.click();
    input.value = query;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    history.pushState(null, '', '#all-designs-heading');
    heading.tabIndex = -1;
    heading.focus({ preventScroll: true });
  });

  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-v65-browse]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const browser = document.querySelector('[data-design-browser]');
    const rail = browser?.querySelector('[data-category-rail]');
    const reset = browser?.querySelector('[data-product-finder-reset]');
    const heading = browser?.querySelector('#all-designs-heading');
    if (!browser || !rail || !reset || !heading) return; // Keep the real fragment fallback.
    event.preventDefault();
    if (navigating) return;
    navigating = true;
    try {
      if (browser.dataset.paperState === 'minimized') {
        browser.querySelector('[data-paper-minimize]')?.click();
        if (!await waitForExpanded(browser)) return;
      }
      history.pushState(null, '', link.hash);
      if (link.dataset.v65Browse === 'all') {
        reset.click();
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      } else {
        const firstTheme = rail.querySelector('[data-product-filter]:not([data-product-filter="all"]):not([data-product-filter="saved"])');
        rail.scrollLeft = 0;
        if (firstTheme && firstTheme.getBoundingClientRect().right > rail.getBoundingClientRect().right) {
          rail.scrollLeft = firstTheme.getBoundingClientRect().left - rail.getBoundingClientRect().left;
        }
        firstTheme?.focus({ preventScroll: true });
        rail.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    } finally {
      navigating = false;
    }
  });
})();
